import * as React from "react"
import { ViewType } from "@digits-graphql/frontend/graphql-bearer"
import { LayoutProvider } from "src/frontend/components/Shared/Layout/LayoutProvider"
import { initialBuilderState, reducer } from "src/frontend/components/Shared/Portals/State/reducer"

export const PortalLayoutProvider: React.FC<React.PropsWithChildren> = ({ children }) => (
  <LayoutProvider
    reducer={reducer}
    initialState={initialBuilderState({
      legalEntityId: "",
      viewType: ViewType.Unknown,
      viewVersion: "",
    })}
  >
    {children}
  </LayoutProvider>
)
